var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroceryStoreCannedSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "64px",
    height: "64px",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "store"
  }), /*#__PURE__*/React.createElement("g", {
    id: "groceries"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fruits"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bakery"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hygiene_product"
  }), /*#__PURE__*/React.createElement("g", {
    id: "detergent"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cooking_oil"
  }), /*#__PURE__*/React.createElement("g", {
    id: "snacks"
  }), /*#__PURE__*/React.createElement("g", {
    id: "canned_food"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73,30h-1.9l1.6-0.7c0.4-0.2,0.7-0.6,0.6-1.1l-0.4-3.1l2-2.5c0.3-0.4,0.3-0.9,0-1.2l-2-2.5l0.4-3.1 c0.1-0.4-0.2-0.9-0.6-1.1l-2.9-1.3l-0.9-3C68.8,10,68.5,9.7,68,9.7L65,9.5l-1.7-2.6c-0.2-0.3-0.6-0.5-1-0.4l-3,0.6L57,4.9 c-0.3-0.3-0.7-0.4-1.1-0.2l-2.8,1.2l-2.6-1.7c-0.3-0.2-0.8-0.2-1.1,0l-2.6,1.7L44,4.7c-0.4-0.2-0.8-0.1-1.1,0.2L40.8,7l-3-0.6 c-0.4-0.1-0.8,0.1-1,0.4L35,9.5L32,9.7c-0.4,0-0.8,0.3-0.9,0.7l-0.9,3l-2.9,1.3c-0.4,0.2-0.7,0.6-0.6,1.1l0.4,3.1l-2,2.5 c-0.3,0.4-0.3,0.9,0,1.2l2,2.5l-0.4,3.1c-0.1,0.4,0.2,0.9,0.6,1.1L29,30h-2c-1.7,0-3,1.3-3,3v60c0,1.7,1.3,3,3,3h46 c1.7,0,3-1.3,3-3V33C76,31.3,74.7,30,73,30z M26,37h48v52H26V37z M32,29.5c-0.1-0.3-0.3-0.5-0.6-0.6l-2.6-1.1l0.4-2.8 c0-0.3,0-0.5-0.2-0.8L27.3,22l1.7-2.2c0.2-0.2,0.2-0.5,0.2-0.8l-0.4-2.8l2.6-1.1c0.3-0.1,0.5-0.4,0.6-0.6l0.8-2.8l2.9-0.2 c0.3,0,0.6-0.2,0.8-0.5L38,8.6l2.9,0.6c0.3,0.1,0.7,0,0.9-0.3l2.1-2.1l2.7,1.1C46.9,8,47.3,8,47.5,7.8L50,6.2l2.5,1.6 C52.7,8,53.1,8,53.4,7.9l2.7-1.1l2.1,2.1c0.2,0.2,0.6,0.3,0.9,0.3L62,8.6l1.6,2.5c0.2,0.3,0.5,0.4,0.8,0.5l2.9,0.2l0.8,2.8 c0.1,0.3,0.3,0.5,0.6,0.6l2.6,1.1L70.8,19c0,0.3,0,0.5,0.2,0.8l1.7,2.2L71,24.2c-0.2,0.2-0.2,0.5-0.2,0.8l0.4,2.8l-2.6,1.1 c-0.3,0.1-0.5,0.4-0.6,0.6L67.9,30H32.1L32,29.5z M27,32h4.4c0,0,0,0,0,0c0,0,0,0,0,0H73c0.6,0,1,0.4,1,1v2H26v-2 C26,32.4,26.4,32,27,32z M73,94H27c-0.6,0-1-0.4-1-1v-2h48v2C74,93.6,73.6,94,73,94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,46c-9.4,0-17,7.6-17,17s7.6,17,17,17s17-7.6,17-17S59.4,46,50,46z M50,78c-8.3,0-15-6.7-15-15s6.7-15,15-15 s15,6.7,15,15S58.3,78,50,78z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "wheat_flour"
  }), /*#__PURE__*/React.createElement("g", {
    id: "milk_powder"
  }), /*#__PURE__*/React.createElement("g", {
    id: "coffee_powder"
  }), /*#__PURE__*/React.createElement("g", {
    id: "tea_bag"
  }), /*#__PURE__*/React.createElement("g", {
    id: "meat"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chicken"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cart"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sausage"
  }), /*#__PURE__*/React.createElement("g", {
    id: "egg"
  }), /*#__PURE__*/React.createElement("g", {
    id: "drink"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vegetable"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroceryStoreCannedSvgrepoCom);
export default __webpack_public_path__ + "static/media/grocery-store-canned-svgrepo-com.94f4d7be4c77d524d8bda4a5e0d92c67.svg";
export { ForwardRef as ReactComponent };